import React, { useState, useEffect } from 'react';
import { Form as BootstrapForm, Button, Modal, Alert } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

interface UserFormProps {
  showModal: boolean;
  handleModalClose: () => void;
  handleSubmit: (data: { displayName?: string; email?: string; phoneNumber?: string; photoUrl?: string }) => void;
  displayName: string;
  email: string;
  phoneNumber: string;
  photoUrl: string;
  verificationMessage: string;
}

const UserForm: React.FC<UserFormProps> = ({
  showModal,
  handleModalClose,
  handleSubmit,
  displayName,
  email,
  phoneNumber,
  photoUrl,
  verificationMessage,
}) => {
  const [formDisplayName, setFormDisplayName] = useState(displayName);
  const [formEmail, setFormEmail] = useState(email);
  const [formPhoneNumber, setFormPhoneNumber] = useState(phoneNumber);
  const [imageSrc, setImageSrc] = useState(photoUrl);

  

  useEffect(() => {
    setFormDisplayName(displayName);
    setFormEmail(email);
    setFormPhoneNumber(phoneNumber);
    setImageSrc(photoUrl);
  }, [displayName, email, phoneNumber, photoUrl]);

  const onSubmit = () => {
    const changes: { displayName?: string; email?: string; phoneNumber?: string; photoUrl?: string } = {};

    if (formDisplayName !== displayName) {
      changes.displayName = formDisplayName;
    }
    if (formEmail !== email) {
      changes.email = formEmail;
    }
    if (formPhoneNumber !== phoneNumber) {
      changes.phoneNumber = formPhoneNumber;
    }
    if (imageSrc !== photoUrl) {
      changes.photoUrl = imageSrc;
    }

    if (Object.keys(changes).length > 0) {
      handleSubmit(changes);
    } else {
      handleModalClose();
    }
  };

  return (
    <Modal show={showModal} onHide={handleModalClose} aria-labelledby="user-form-modal">
      <Modal.Header closeButton>
        <Modal.Title id="user-form-modal">
          This is it
          Additional Information
          <small style={{ fontSize: '0.75rem' }} className="text-muted d-block">
            This data comes from your email address. Please check if this data is correct.
          </small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <img
            src={imageSrc}
            alt="User "
            className="rounded-circle"
            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
            onError={() => setImageSrc('assets/icons/man.PNG')}
          />
        </div>
        <p className="mt-3 mb-0 text-center font-weight-bold">{formEmail}</p>
        {verificationMessage && (
          <Alert variant="warning" className="text-center">
            {verificationMessage}
          </Alert>
        )}
        <BootstrapForm>
          <BootstrapForm.Group className="mb-3" controlId="FullName">
            <BootstrapForm.Label>Full Name</BootstrapForm.Label>
            <BootstrapForm.Control
              type="text"
              placeholder="Enter Full Name"
              value={formDisplayName}
              onChange={(e) => setFormDisplayName(e.target.value)}
              aria-label="Full Name"
            />
          </BootstrapForm.Group>
          <BootstrapForm.Group className="mb-3" controlId="formPhoneNumber">
            <BootstrapForm.Label>Phone Number</BootstrapForm.Label>
            <PhoneInput
              country={'lk'}
              value={formPhoneNumber}
              onChange={(phone) => setFormPhoneNumber(phone)}
              inputProps={{
                'aria-label': 'Phone Number',
              }}
            />
          </BootstrapForm.Group>
        </BootstrapForm>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserForm;
